// extracted by mini-css-extract-plugin
export default {"greenButton":"GreenButtons_greenButton__OOqQU","lightGreenButton":"GreenButtons_lightGreenButton__s1ZT3"};